import { useQuery } from "react-query";
import { getWaybill } from "../../../../../services/sales-point";
import { useParams } from "react-router-dom";

const useViewWaybill = () => {
  const params = useParams();
  const { data: waybills, isLoading: loadingWaybills } = useQuery(
    ["waybills", params?.id],
    () => getWaybill(params?.id).then((res) => res.data?.data),
    {
      enabled: params?.id ? true : false,
    },
  );
  return {
    waybills,
    loadingWaybills,
  };
};

export default useViewWaybill;
